export class VendorProduct {
  productId: number;
  markupPercent: number;
}
